var semanticTokens = {
  colors: {
    acceleratePurple: 'purple.500',

    /* FleetView */
    adaBlue: 'blue.300',
    adaGray: 'gray.700',
    brakeRed: ' red.400',

    /* FleetView */
    bronze: 'orange.600',

    /* Driver Cup */
    componentGray: 'gray.200',
    cornerOrange: 'orange.400',

    /* FleetView */
    darkBlue: 'blue.900',

    /* Team Banner */
    darkGray: 'gray.900',
    error: 'red.500',
    fluidBlue: 'blue.500',
    gold: 'yellow.600',

    /* Driver Cup */
    info: 'blue.500',
    keylineGray: 'gray.400',
    lightBlue: 'blue.200',
    lightestGray: 'gray.50',
    lightGray: 'gray.100',
    midGray: 'gray.500',

    /* aka fluidGray */
    privateYellow: 'yellow.400',

    /* FleetView */
    secondaryGray: 'gray.800',
    silver: 'gray.600',

    /* Driver Cup */
    success: 'green.500',
    successBg: 'rgba(0, 171, 97, 0.1)',

    /* 10% success green */
    warning: 'orange.500',

    /* Battery Warning */
    warningBg: 'rgba(226, 140, 1, 0.1)'
  }
};
export default semanticTokens;
//# sourceMappingURL=semantic-tokens.js.map